import _get from 'lodash/get';
import axios from 'axios';
import { fetchRelatedArticle } from './action-related-article';
import { contactByEmailNoIntent } from './action-contact-option';
import { requestTopicData, receiveTopicDataError } from './action-topic-data';
import { updateUserSelection } from './action-update-user-selection';
import * as types from '../constants/ActionTypes';

export function emailIntentSelected(topicName) {
  return (dispatch) => {
    dispatch(fetchRelatedArticle(topicName));
    dispatch(contactByEmailNoIntent());
    dispatch({
      type: types.EMAIL_INTENT_SELECTED_NO_INTENT,
      payload: true,
    });
  };
}
function receiveFormFieldsNoIntent(responseData) {
  const formFields = _get(responseData, 'formInfo.form_elements.webform_detail', []);
  const kanaCode = _get(responseData, 'formInfo.kana_code', '');
  const topicRefId = _get(responseData, 'formInfo.topicRefId', '');

  return {
    type: types.RECEIVE_FORM_FIELDS_NO_INTENT,
    payload: {
      kanaCode,
      formFields,
      topicRefId,
    },
  };
}

export function receiveFormNoIntent(response) {
  // webform_detail comes as [] -> so default value should be []
  const formFields = _get(response, 'formInfo.form_elements.webform_detail', []);
  return (dispatch) => {
    dispatch(contactByEmailNoIntent(formFields));
  };
}

export function receiveTopicDataNoIntent(responseData) {
  const contactChannel = _get(responseData, 'formInfo.form_elements.contact_channel', []);
  return {
    type: types.RECEIVE_CONTACT_CHANNELS_NO_DATA,
    payload: contactChannel,
  };
}

export function fetchFormElementsNoIntent(topicId, logout = false) {
  return (dispatch) => {
    dispatch(requestTopicData(topicId));
    axios
      .get(`/smarthelp/topic-data/?topic_id=${topicId}`)
      .then((response) => {
        dispatch(receiveTopicDataNoIntent(response.data));
        dispatch(receiveFormFieldsNoIntent(response.data));
        dispatch(receiveFormNoIntent(response.data));
        if (!logout) {
          dispatch(updateUserSelection('emailByPassPage'));
        }
      })
      .catch((error) => {
        if (error && error.message !== types.ERROR_TOPIC_TREE) {
          dispatch(receiveTopicDataError());
        }
      });
  };
}

export function accessLogoutEmail() {
  return { type: types.ACCESS_LOGOUT_EMAIL };
}

// When user clicked on No account link on email page
export const showEmailWebForm = () => ({ type: types.DISPLAY_LOGOUT_WEB_FORM });
